<script lang="ts">
/**
 * To be placed on components that exist inside a component that listens for page loading events.
 * The initial (and mayber only) use case is the review submission flow. As each "page" is moved
 * to, this fires a "pageLoading" event that triggers a spinner at the top level component
 * (review-submission-modal). It is the responsibility of each individual "page" component to
 * call the "pageLoaded" method here, which fires the "pageLoaded" event that tells the
 * review-submission-modal to remove the spinner and display the content.
 */
export default {
  emits: ['pageLoaded', 'pageLoading'],
  methods: {
    pageLoaded(preventClickOutside = false) {
      this.$emit('pageLoaded', preventClickOutside)
    }
  },
  created() {
    this.$emit('pageLoading')
  },
  activated() {
    this.$emit('pageLoading')
  }
}
</script>
